// 轉盤中獎 (一般、Bonus)
import Image from 'next/image';

const CampaignSpinWinning = ({
    winningGrid,
    winningAmount,
    drawTime,
    onStart,
    onClose,
    isSpinning,
    bonus,
}) => {
    return (
        <>
            <p className="text-bd5n text-[#fff] uxs:text-[1.35rem]">
                \ {winningGrid === 16 ? '恭喜獲得 Bonus 獎勵' : '恭喜中獎'} /{' '}
            </p>

            {/* 獎項名稱 */}
            {winningGrid === 16 ? (
                // bonus 獎勵
                <>
                    <p className="px-[15px] py-[5px] text-bd4n text-[#91ffff] bg-[#0f4f3c] bg-opacity-[.22] rounded-[4px] backdrop-blur-[10px] my-[12px] uxs:px-[2px]">
                        活動結束將以信件主動聯繫您領取獎品
                    </p>
                    <div className="flex items-center gap-x-[24px] my-[20px] uxs:gap-x-[15px] uxs:my-0">
                        <div className="img-box w-[73px] aspect-[1/1] rounded-[6px] overflow-hidden after:content-none uxs:w-[68px]">
                            <Image src={bonus?.image} width={73} height={73} alt="bonus" />
                        </div>
                        <div className="text-left text-[#fff] text-btn1 flex-grow space-y-[3px]">
                            <p>{bonus?.name}</p>
                            <p>{bonus?.desc}</p>
                        </div>
                    </div>
                </>
            ) : (
                // 一般獎勵
                <>
                    <p className="text-bd2n my-[12px] text-[#fff] usm:my-[10px]">
                        獲得抽獎券 X {winningAmount}
                    </p>

                    <p className="text-bd1b text-[#0ff]">本日開獎時間：今晚{drawTime}</p>
                </>
            )}

            <button
                onClick={onStart}
                className="max-w-[287px] w-full py-[10px] text-bd1b text-[#fff] mx-auto my-[16px] block
                border-1 border-[#fff] border-opacity-[.52] rounded-[40px] trans hover:bg-[#0083A0] usm:my-[13px] [@media(max-width:388px)]:py-[7px]"
            >
                再轉一次
            </button>
            <p className="text-bd3n text-[#fff] mb-[20px] usm:mb-[15px]">
                點擊表示已閱畢活動條款與隱私權條款
            </p>
            <button
                onClick={onClose}
                className={`px-[35px] inline-block mx-auto py-[6px] rounded-[4px] text-bd4n text-[#fff] bg-[#fff] bg-opacity-[.11]
                ${isSpinning ? 'cursor-not-allowed' : ''}`}
            >
                關閉
            </button>
        </>
    );
};

export default CampaignSpinWinning;
